const projectsPageData = [
    // COMPLETED PROJECTS
    // Existing projects - Apartments
    {
        "id": 1,
        "slug": "duplex-branduselor-floresti",
        "title": "Duplex House on Branduselor St, Florești",
        "category": "Duplex",
        "year": "2021",
        "location": "Florești, Cluj County (Near Vivo Mall)",
        "address": "Strada Branduselor, Florești, Cluj",
        "startDate": null,
        "endDate": "2021-09-30",
        "status": "Completed Projects",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/3.png",
        "description": "A new Arcdom brand project! Semi-detached houses located in a residential area, with a private road entering from Branduselor Street, Florești. Features easy access to the newly paved South road. Just 2 steps from Vivo Mall. ",
        "features": [
            { "icon": "FaRulerCombined", "text": "120 sqm usable area" },
            { "icon": "FaThermometerHalf", "text": "Underfloor Heating" },
            { "icon": "MdWindow", "text": "Triple Glazed Windows, PVC Joinery" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/1.png",
            "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/2.png",
            "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/3.png",
            "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/4.png"
        ],
        "configurations": [
            { "type": "Building Type", "details": "GF+1F (Ground Floor + 1 Floor)" }
        ]
    },
    {
        "id": 2,
        "slug": "apartments-padurii-60-62",
        "title": "2 & 3 Room Apartments, Padurii St 60-62",
        "category": "Apartments",
        "year": "2020",
        "location": "Cluj-Napoca (North Bypass Area)",
        "address": "Strada Padurii 60-62, Cluj-Napoca",
        "startDate": null,
        "endDate": "2020-12-31",
        "status": "Completed Projects",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/1.png",
        "description": "2 and 3 room apartments featuring underfloor heating. The building is located on Padurii Street 60-62, on the North bypass. Easy access to the Transilvania Highway and the North Donath-Grigorescu bypass.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "2 & 3 Room Units" },
            { "icon": "FaThermometerHalf", "text": "Underfloor Heating" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/1.png",
            "https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/2.png",
            "https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/3.png"
        ],
        "configurations": [
            { "type": "Building Type", "details": "B+GF+1F (Basement + Ground Floor + 1 Floor)" }
        ]
    },
    {
        "id": 4,
        "slug": "apartments-padurii-62-donath",
        "title": "2 & 3 Room Apartments, Padurii St 62 (Donath Park)",
        "category": "Apartments",
        "year": "2021",
        "location": "Cluj-Napoca (Donath Park Area)",
        "address": "Strada Padurii 62, Cluj-Napoca",
        "startDate": null,
        "endDate": "2021-06-30",
        "status": "Completed Projects",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/apartamente-grigorescu/1.png",
        "description": "Apartments located on Padurii St 62, on the North bypass (Donath-Grigorescu), known as Donath Park. Features include underfloor heating and anti-burglary entrance doors. Apartments delivered semi-finished with two coats of plaster.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "2 & 3 Room Units" },
            { "icon": "FaThermometerHalf", "text": "Underfloor Heating" },
            { "icon": "FaCheckCircle", "text": "Semi-finished (2 coats plaster)" },
            { "icon": "FaCheckCircle", "text": "Anti-burglary Entrance Door" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/apartamente-grigorescu/1.png",
            "https://arcdom.b-cdn.net/arcdom-projects/apartamente-grigorescu/2.png",
        ],
        "configurations": [
            { "type": "Unit Ap. 4", "details": "56.65 sqm + 100 sqm garden" },
            { "type": "Unit Ap. 10 (2 Levels)", "details": "34.13 sqm + 49.37 sqm attic (Total 83.5 sqm)" },
            { "type": "Unit Ap. 11 (2 Levels)", "details": "33.5 sqm + 56.85 sqm attic (Total 90.35 sqm)" },
            { "type": "Unit Ap. 12 (2 Levels)", "details": "52.2 sqm + 51.57 sqm attic (Total 103.77 sqm)" }
        ]
    },
    {
        "id": 5,
        "slug": "apartments-terra-floresti-192",
        "title": "Apartments in Terra Florești (Sesul de Sus 192)",
        "category": "Apartments",
        "year": "2021",
        "location": "Terra Florești, Florești",
        "address": "Strada Sesul de Sus 192, Florești, Cluj",
        "startDate": null,
        "endDate": "2021-04-30",
        "status": "Completed Projects",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/apartament-terra/1.jpeg",
        "description": "Apartments located in the Terra Florești neighborhood on Sesul de Sus St 192, very close to the M22 bus station! Building features an elevator and underground parking. The complex includes a children's playground and a grocery store. Easy access to Transilvania Highway and North Donath-Grigorescu bypass.",
        "features": [
            { "icon": "MdElevator", "text": "Elevator" },
            { "icon": "FaParking", "text": "Underground Parking" },
            { "icon": "FaChild", "text": "Children's Playground" },
            { "icon": "FaStore", "text": "Grocery Store in Complex" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/apartament-terra/1.jpeg",
        ],
        "configurations": [
            { "type": "3 Rooms", "details": "68.7 sqm + 2 balconies (Total 14 sqm)" },
            { "type": "2 Rooms (Type 1)", "details": "57 sqm + 6 sqm balcony" },
            { "type": "2 Rooms (Type 2)", "details": "50.71 sqm (High, double-insulated ground floor)" },
            { "type": "2 Rooms Penthouse", "details": "51.5 sqm + 31.4 sqm terrace" }
        ]
    },
    {
        "id": 6,
        "slug": "project-sesul-de-sus-190",
        "title": "Commercial Space Sesul de Sus 190",
        "category": "Commercial Spaces",
        "year": "2022",
        "location": "Terra Florești, Florești",
        "address": "Strada Sesul de Sus 190, Florești, Cluj",
        "startDate": "2021-03-01",
        "endDate": "2022-06-30",
        "status": "Completed Projects",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/5.png",
        "description": "Project started March 1st, 2021. Building includes an elevator and ground-floor commercial spaces (grocery store, services). The complex features a children's playground, an 8m wide road with two 1m sidewalks, and underground parking interconnected with the elevator. 5 apartment configurations available.",
        "features": [
            { "icon": "MdElevator", "text": "Elevator" },
            { "icon": "FaStore", "text": "Ground Floor Commercial Spaces" },
            { "icon": "FaChild", "text": "Children's Playground" },
            { "icon": "FaParking", "text": "Underground Parking (connected to lift)" },
            { "icon": "FaRulerCombined", "text": "Wide Road (8m + 2x1m sidewalks)" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/1.png",
            "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/2.png",
            "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/3.png",
            "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/5.png",
            "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/6.png",
        ],
        "configurations": [
            { "type": "Config 1 (3 Rooms)", "details": "68.8 sqm + 2 balconies (14 sqm total)" },
            { "type": "Config 2 (2 Rooms)", "details": "57 sqm + 6 sqm balcony" },
            { "type": "Config 3 (2 Rooms)", "details": "45.10 sqm + 10 sqm terrace" },
            { "type": "Config 4 (2 Rooms Penthouse)", "details": "51.5 sqm + 31.4 sqm terrace (5th floor, East exposure)" },
            { "type": "Config 5", "details": "Details available on request (Contact for plans)" }
        ]
    },

    // New projects - Completed - Apartments
    // {
    //     "id": 9,
    //     "slug": "catanelor-2014-2016",
    //     "title": "Catanelor 2014-2016 - 96 Apartments",
    //     "category": "Apartments",
    //     "year": "2016",
    //     "location": "Florești, Cluj County",
    //     "address": "Strada Catanelor, Florești, Cluj",
    //     "startDate": "2014-01-01",
    //     "endDate": "2016-12-31",
    //     "status": "Completed Projects",
    //     "mainImage": "/images/placeholder-project.jpg",
    //     "description": "Residential complex featuring 96 apartments built between 2014 and 2016 on Catanelor Street in Florești.",
    //     "features": [
    //         { "icon": "MdOutlineApartment", "text": "96 Apartment Units" }
    //     ],
    //     "gallery": [
    //         "/images/placeholder-project.jpg"
    //     ],
    //     "configurations": []
    // },
    {
        "id": 10,
        "slug": "tauti-13-floresti",
        "title": "Tauti 13 Florești - Commercial Space & 7 Apartments",
        "category": ["Apartments", "Commercial Spaces"],
        "year": "2016",
        "location": "Florești, Cluj County",
        "address": "Strada Tauti 13, Florești, Cluj",
        "startDate": "2015-01-01",
        "endDate": "2016-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Mixed-use development featuring commercial space on the ground floor and 7 residential apartments above.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "7 Apartment Units" },
            { "icon": "FaStore", "text": "Ground Floor Commercial Space" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Tauti%2013%20Flore%C8%99ti%20-sp%20comercial%20%C8%99i%207ap%20-%202016/WhatsApp%20Image%202025-05-22%20at%2013.38.05.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Tauti%2013%20Flore%C8%99ti%20-sp%20comercial%20%C8%99i%207ap%20-%202016/WhatsApp%20Image%202025-05-22%20at%2013.38.05%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Tauti%2013%20Flore%C8%99ti%20-sp%20comercial%20%C8%99i%207ap%20-%202016/WhatsApp%20Image%202025-05-22%20at%2013.38.05%20(2).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Tauti%2013%20Flore%C8%99ti%20-sp%20comercial%20%C8%99i%207ap%20-%202016/WhatsApp%20Image%202025-05-22%20at%2013.38.05%20(3).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Tauti%2013%20Flore%C8%99ti%20-sp%20comercial%20%C8%99i%207ap%20-%202016/WhatsApp%20Image%202025-05-22%20at%2013.38.05%20(4).jpeg"
        ],
        "configurations": []
    },
    {
        "id": 11,
        "slug": "catanelor-9b-9h",
        "title": "Floresti, str Cătanelor 9b și 9h - 25 Apartments",
        "category": "Apartments",
        "year": "2021",
        "location": "Florești, Cluj County",
        "address": "Strada Catanelor 9b și 9h, Florești, Cluj",
        "startDate": "2019-01-01",
        "endDate": "2021-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Residential development with 25 apartment units on Catanelor Street, completed between 2019 and 2021.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "25 Apartment Units" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Apartamente%20str%20c%C4%83tanelor%209b%20%C8%99i%209h%20-%2025%20ap%20An%202019-2021/WhatsApp%20Image%202025-05-22%20at%2013.38.08.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Apartamente%20str%20c%C4%83tanelor%209b%20%C8%99i%209h%20-%2025%20ap%20An%202019-2021/WhatsApp%20Image%202025-05-22%20at%2013.38.08%20(2).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Apartamente%20str%20c%C4%83tanelor%209b%20%C8%99i%209h%20-%2025%20ap%20An%202019-2021/WhatsApp%20Image%202025-05-22%20at%2013.38.08%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Apartamente%20str%20c%C4%83tanelor%209b%20%C8%99i%209h%20-%2025%20ap%20An%202019-2021/WhatsApp%20Image%202025-05-22%20at%2013.38.07.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Apartamente%20str%20c%C4%83tanelor%209b%20%C8%99i%209h%20-%2025%20ap%20An%202019-2021/WhatsApp%20Image%202025-05-22%20at%2013.38.07%20(1).jpeg"
        ],
        "configurations": []
    },
    {
        "id": 12,
        "slug": "teilor-47-floresti",
        "title": "Str Teilor 47 Florești - 30 Apartments",
        "category": "Apartments",
        "year": "2017",
        "location": "Florești, Cluj County",
        "address": "Strada Teilor 47, Florești, Cluj",
        "startDate": null,
        "endDate": "2017-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Residential building with 30 apartment units completed in 2017 on Teilor Street in Florești.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "30 Apartment Units" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20Teilor%2047%20Flore%C8%99ti%20%20An%202017%20%2030%20ap/WhatsApp%20Image%202025-05-22%20at%2013.38.09%20(3).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20Teilor%2047%20Flore%C8%99ti%20%20An%202017%20%2030%20ap/WhatsApp%20Image%202025-05-22%20at%2013.38.09%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20Teilor%2047%20Flore%C8%99ti%20%20An%202017%20%2030%20ap/WhatsApp%20Image%202025-05-22%20at%2013.38.09%20(2).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20Teilor%2047%20Flore%C8%99ti%20%20An%202017%20%2030%20ap/WhatsApp%20Image%202025-05-22%20at%2013.38.09.jpeg"
        ],
        "configurations": []
    },
    {
        "id": 13,
        "slug": "a-iancu-410-volvo",
        "title": "Str A Iancu 410 (Volvo) Florești - 60 Apartments",
        "category": "Apartments",
        "year": "2020",
        "location": "Florești, Cluj County",
        "address": "Strada A. Iancu 410, Florești, Cluj",
        "startDate": "2018-01-01",
        "endDate": "2020-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Residential complex with 60 apartments built between 2018 and 2020, located near the Volvo area on A. Iancu Street in Florești.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "60 Apartment Units" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20A%20Iancu%20410_volvo%20Flore%C8%99ti%20%20An%202018-2020/WhatsApp%20Image%202025-05-22%20at%2013.38.10%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20A%20Iancu%20410_volvo%20Flore%C8%99ti%20%20An%202018-2020/WhatsApp%20Image%202025-05-22%20at%2013.38.09%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20A%20Iancu%20410_volvo%20Flore%C8%99ti%20%20An%202018-2020/WhatsApp%20Image%202025-05-22%20at%2013.38.09.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Str%20A%20Iancu%20410_volvo%20Flore%C8%99ti%20%20An%202018-2020/WhatsApp%20Image%202025-05-22%20at%2013.38.10.jpeg"
        ],
        "configurations": []
    },
    {
        "id": 14,
        "slug": "catanelor-11g-11k",
        "title": "Catanelor 11g și 11k - 60 Apartments",
        "category": "Apartments",
        "year": "2023",
        "location": "Florești, Cluj County",
        "address": "Strada Catanelor 11g și 11k, Florești, Cluj",
        "startDate": "2021-01-01",
        "endDate": "2023-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Modern residential complex featuring 60 apartment units built between 2021 and 2023 on Catanelor Street in Florești.",
        "features": [
            { "icon": "MdOutlineApartment", "text": "60 Apartment Units" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Catanelor%2011g%20%C8%99i%2011k%20-%2060%20ap%20Construc%C8%9Bie%202021-2023/WhatsApp%20Image%202025-05-22%20at%2013.38.12.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Catanelor%2011g%20%C8%99i%2011k%20-%2060%20ap%20Construc%C8%9Bie%202021-2023/WhatsApp%20Image%202025-05-22%20at%2013.38.12%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Catanelor%2011g%20%C8%99i%2011k%20-%2060%20ap%20Construc%C8%9Bie%202021-2023/WhatsApp%20Image%202025-05-22%20at%2013.38.13.jpeg"
        ],
        "configurations": []
    },

    // New projects - Completed - Duplex
    {
        "id": 15,
        "slug": "ansamblu-duplexuri-urusagului",
        "title": "Ansamblu 15 Duplexuri Urusagului Florești",
        "category": "Duplex",
        "year": "2019",
        "location": "Florești, Cluj County",
        "address": "Strada Urusagului, Florești, Cluj",
        "startDate": "2016-01-01",
        "endDate": "2019-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Residential complex consisting of 15 duplex units built between 2016 and 2019 on Urusagului Street in Florești.",
        "features": [
            { "icon": "FaHome", "text": "15 Duplex Units" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Ansamblu%2015%20duplexuri%20Urusagului%20Flore%C8%99ti%20An%202016-2019/WhatsApp%20Image%202025-05-22%20at%2013.38.06%20(2).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Ansamblu%2015%20duplexuri%20Urusagului%20Flore%C8%99ti%20An%202016-2019/WhatsApp%20Image%202025-05-22%20at%2013.38.06.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Ansamblu%2015%20duplexuri%20Urusagului%20Flore%C8%99ti%20An%202016-2019/WhatsApp%20Image%202025-05-22%20at%2013.38.06%20(1).jpeg"
        ],
        "configurations": []
    },
    {
        "id": 16,
        "slug": "duplexuri-narciselor",
        "title": "Duplexuri Floresti, Strada Narciselor",
        "category": "Duplex",
        "year": "2018",
        "location": "Florești, Cluj County",
        "address": "Strada Narciselor, Florești, Cluj",
        "startDate": "2017-01-01",
        "endDate": "2018-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Duplex housing development on Narciselor Street in Florești, completed between 2017 and 2018.",
        "features": [
            { "icon": "FaHome", "text": "Duplex Units" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Duplexuri%20narciselor%20An%202017-2018/WhatsApp%20Image%202025-05-22%20at%2013.38.07%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Duplexuri%20narciselor%20An%202017-2018/WhatsApp%20Image%202025-05-22%20at%2013.38.07.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Duplexuri%20narciselor%20An%202017-2018/WhatsApp%20Image%202025-05-22%20at%2013.38.06%20(3).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Duplexuri%20narciselor%20An%202017-2018/WhatsApp%20Image%202025-05-22%20at%2013.38.06%20(4).jpeg"
        ],
        "configurations": []
    },
    {
        "id": 17,
        "slug": "primele-duplexuri-urusagului",
        "title": "Primele Duplexuri 2014 Urusagului Florești",
        "category": "Duplex",
        "year": "2014",
        "location": "Florești, Cluj County",
        "address": "Strada Urusagului, Florești, Cluj",
        "startDate": null,
        "endDate": "2014-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "The first duplex housing project on Urusagului Street in Florești, completed in 2014.",
        "features": [
            { "icon": "FaHome", "text": "First Duplex Development" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Primele%20duplexuri%202014%20Urusagului%20Flore%C8%99ti/WhatsApp%20Image%202025-05-22%20at%2013.38.10.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Primele%20duplexuri%202014%20Urusagului%20Flore%C8%99ti/WhatsApp%20Image%202025-05-22%20at%2013.38.10%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Primele%20duplexuri%202014%20Urusagului%20Flore%C8%99ti/WhatsApp%20Image%202025-05-22%20at%2013.38.10%20(2).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Primele%20duplexuri%202014%20Urusagului%20Flore%C8%99ti/WhatsApp%20Image%202025-05-22%20at%2013.38.10%20(3).jpeg"
        ],
        "configurations": []
    },

    // New projects - Completed - Commercial Spaces
    {
        "id": 18,
        "slug": "spatiu-comercial-eroilor",
        "title": "Spatiu Comercial Eroilor 58H Floresti",
        "category": "Commercial Spaces",
        "year": "2019",
        "location": "Florești, Cluj County",
        "address": "Strada Eroilor 58H, Florești, Cluj",
        "startDate": null,
        "endDate": "2019-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Commercial space development located on Eroilor Street 58H in Florești.",
        "features": [
            { "icon": "FaStore", "text": "Commercial Space" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Spatiu%20comercial%20eroilor%2058H%20Floresti/WhatsApp%20Image%202025-05-22%20at%2013.38.11.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Spatiu%20comercial%20eroilor%2058H%20Floresti/WhatsApp%20Image%202025-05-22%20at%2013.38.11%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Spatiu%20comercial%20eroilor%2058H%20Floresti/WhatsApp%20Image%202025-05-22%20at%2013.38.11%20(2).jpeg"
        ],
        "configurations": []
    },
    {
        "id": 19,
        "slug": "spatiu-comercial-catanelor",
        "title": "Spatiu Comercial Catanelor 9B Floresti",
        "category": "Commercial Spaces",
        "year": "2021",
        "location": "Florești, Cluj County",
        "address": "Strada Catanelor 9B, Florești, Cluj",
        "startDate": null,
        "endDate": "2021-12-31",
        "status": "Completed Projects",
        "mainImage": "/images/placeholder-project.jpg",
        "description": "Commercial space development located on Catanelor Street 9B in Florești.",
        "features": [
            { "icon": "FaStore", "text": "Commercial Space" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Sp%20comercial%20Catanelor%209B/WhatsApp%20Image%202025-05-22%20at%2013.38.11%20(1).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Sp%20comercial%20Catanelor%209B/WhatsApp%20Image%202025-05-22%20at%2013.38.11%20(2).jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Sp%20comercial%20Catanelor%209B/WhatsApp%20Image%202025-05-22%20at%2013.38.11.jpeg"
        ],
        "configurations": []
    },

    // WORK IN PROGRESS PROJECTS
    {
        "id": 3,
        "slug": "duplex-iazului-floresti",
        "title": "Duplex House on Iazului St, Florești",
        "category": "Duplex",
        "year": "2025",
        "location": "Florești, Cluj County",
        "address": "Strada Iazului, Florești, Cluj",
        "startDate": "2024-01-01",
        "endDate": null,
        "status": "Work In Progress",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/1.png",
        "description": "Duplex house featuring 4 bedrooms, living room plus kitchen, and 2 bathrooms. Includes 2 balconies and 2 terraces. Easy access to Transilvania Highway and North Donath-Grigorescu bypass.",
        "features": [
            { "icon": "FaBed", "text": "4 Bedrooms" },
            { "icon": "FaBath", "text": "2 Bathrooms" },
            { "icon": "FaRulerCombined", "text": "117.6 sqm usable area" },
            { "icon": "FaRulerCombined", "text": "182.5 sqm built area" },
            { "icon": "FaRulerCombined", "text": "254 sqm land per unit" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/1.png",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/2.png",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/3.png",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/4.png",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/5.png"
        ],
        "configurations": [
            { "type": "Building Type", "details": "GF+1F" },
            { "type": "Terraces", "details": "2 Terraces (Total 19.8 sqm)" },
            { "type": "Balconies", "details": "2 Balconies (Total 12.7 sqm)" }
        ]
    },
    {
        "id": 21,
        "slug": "terra-gardens-valea-chintaului",
        "title": "Terra Gardens",
        "category": "Apartments",
        "year": "2025",
        "location": "Valea Chintaului",
        "address": "Valea Chintaului, Cluj",
        "startDate": "2024-01-01",
        "endDate": null,
        "status": "Work In Progress",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Terra%20Gardens/1.jpeg",
        "description": "Modern residential complex featuring 29 apartment units in Valea Chintaului. The development offers 2 and 3 room apartments delivered semi-finished with underground parking included. ",
        "features": [
            { "icon": "MdOutlineApartment", "text": "29 Apartment Units" },
            { "icon": "MdOutlineApartment", "text": "2 & 3 Room Units" },
            { "icon": "FaRulerCombined", "text": "41 - 76 sqm" },
            { "icon": "FaParking", "text": "Underground Parking Included" },
            { "icon": "FaCheckCircle", "text": "Semi-finished Apartments" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/Terra%20Gardens/1.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Terra%20Gardens/2.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/Terra%20Gardens/3.jpeg"
        ],
        "configurations": [
            { "type": "Total Units", "details": "29 Apartments" },
            { "type": "Available Types", "details": "2 Room & 3 Room Apartments" },
            { "type": "Surface Area", "details": "Between 41 - 76 sqm" }
        ]
    },
    {
        "id": 7,
        "slug": "someseni-barc-st-1",
        "title": "Apartments Barc St 1 (61-63), Someșeni",
        "category": "Apartments",
        "year": "2025",
        "location": "Someșeni, Cluj-Napoca",
        "address": "Strada Barc 1, Nr. 61-63, Cluj-Napoca",
        "startDate": "2023-01-01",
        "endDate": "2025-02-28",
        "status": "Work In Progress",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/someseni/4.jpeg",
        "description": "Live in comfort and peace in the new residential project on Barc St 1, Someșeni, Cluj-Napoca. Apartments delivered semi-finished with individual thermal plants, underfloor heating, and plastered walls (2 coats). Delivery expected October 2024, Land Registration February 2025.",
        "features": [
            { "icon": "FaFireAlt", "text": "Individual Heating System" },
            { "icon": "FaThermometerHalf", "text": "Underfloor Heating" },
            { "icon": "FaCheckCircle", "text": "Semi-finished (Plastered)" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/someseni/1.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/someseni/2.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/someseni/3.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/someseni/4.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/someseni/5.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/someseni/6.jpeg"
        ],
        "configurations": [
            { "type": "Type 1 (GF)", "details": "3 Rooms (67 sqm), 2 Baths, 50 sqm basement storage, Garden. Price: €200,000 + VAT" },
            { "type": "Type 2 (1F)", "details": "3 Rooms (66.7 sqm), 2 Beds, 2 Baths, Living+Kitchen, 3.3 sqm loggia. Price: €152,500 + VAT (Limited availability)" },
            { "type": "Type 3 (2F)", "details": "3 Rooms (67 sqm), 3 sqm loggia, 50 sqm terrace, 9 sqm office. Price: €185,000 + VAT" }
        ]
    },
    {
        "id": 8,
        "slug": "duplex-urusagului-floresti",
        "title": "Duplex Project - Urușagului St, Florești",
        "category": "Duplex",
        "year": "2025",
        "location": "Florești, Cluj County",
        "address": "Strada Urușagului, Florești, Cluj",
        "startDate": "2024-01-01",
        "endDate": null,
        "status": "Work In Progress",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/1.jpeg",
        "description": "New duplex project located on Urușagului Street in Florești. Different types available, check PDF plans for details.",
        "features": [
            { "icon": "FaFilePdf", "text": "Floor Plans Available (PDF)" }
        ],
        "gallery": [
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/1.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/2.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/3.jpeg",
            "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/4.jpeg"
        ],
        "configurations": [
            { "type": "Availability", "details": "Multiple duplex types available" }
        ]
    }
];

export default projectsPageData;
